/**
 * collection-infinite-scroll.js
 * Infinite scroll for Shopify collection pages.
 */

(function () {
  'use strict';

  const productGrid = document.querySelector('#product-grid');
  if (!productGrid || productGrid.dataset.paginationType !== 'infinite') return;

  const productList = productGrid.querySelector('.product-grid-container');
  const trigger     = productGrid.querySelector('.infinite-scroll-trigger');
  const loader      = productGrid.querySelector('.infinite-scroll-loader');

  if (!productList || !trigger) {
    console.warn('[IS] Trigger ya productList nahi mila.');
    return;
  }

  let isLoading = false;

  function getNextUrl() {
    const url = trigger.dataset.nextUrl;
    return url && url.trim() !== '' ? url : null;
  }

  function setNextUrl(url) {
    trigger.dataset.nextUrl = url || '';
    trigger.dataset.hasNext = url ? 'true' : 'false';
  }

  function showLoader() { if (loader) loader.style.display = 'flex'; }
  function hideLoader() { if (loader) loader.style.display = 'none'; }

  function reinitSwymWishlist() {
    if (window.swymApi && typeof window.swymApi.initializeActionButtons === 'function') {
      window.swymApi.initializeActionButtons('.product-grid-container');
    } else {
      document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
    }
  }

  async function loadNextPage() {
    const nextUrl = getNextUrl();
    if (!nextUrl || isLoading) return;

    isLoading = true;
    showLoader();

    // Observer temporarily disconnect — re-observe baad mein
    observer.unobserve(trigger);

    try {
      const res = await fetch(nextUrl);
      if (!res.ok) throw new Error('Fetch failed: ' + res.status);

      const html = await res.text();
      const doc  = new DOMParser().parseFromString(html, 'text/html');

      const newItems = doc.querySelectorAll('.product-grid-item');
      newItems.forEach(item => productList.appendChild(item));

      reinitSwymWishlist();

      const newTrigger  = doc.querySelector('.infinite-scroll-trigger');
      const nextPageUrl = newTrigger?.dataset?.nextUrl || null;
      setNextUrl(nextPageUrl);

      if (!nextPageUrl) {
        trigger.style.display = 'none';
        // Aur pages nahi — observer band
      } else {
        // Agle page ke liye dobara observe karo
        observer.observe(trigger);
      }

    } catch (err) {
      console.error('[IS] Error:', err);
      // Error pe bhi dobara observe karo retry ke liye
      observer.observe(trigger);
    } finally {
      isLoading = false;
      hideLoader();
    }
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && trigger.dataset.hasNext === 'true') {
          loadNextPage();
        }
      });
    },
    { rootMargin: '0px 0px 600px 0px' }
  );

  observer.observe(trigger);

})();